/**
 * taskbarStore.js — reactive preference for the always-visible taskbar (#336).
 *
 * Stored in localStorage so it persists for both anon and logged-in users
 * without an additional API round-trip. Default: true (always visible).
 *
 * Persistence boundary: localStorage `redfur-taskbar-always-visible`.
 * Logged-in users can also save this to their prefs blob via the
 * HomeMenu Settings checkbox (which calls setAlwaysVisible()).
 */
import { createSignal } from 'solid-js';

const LS_KEY = 'redfur-taskbar-always-visible';

function _loadPref() {
  try {
    const v = localStorage.getItem(LS_KEY);
    if (v === null) return true; // default: always visible
    return v !== 'false';
  } catch { return true; }
}

const [alwaysVisible, _setAlwaysVisible] = createSignal(_loadPref());

function setAlwaysVisible(v) {
  const next = !!v;
  try { localStorage.setItem(LS_KEY, String(next)); } catch { /* storage quota */ }
  _setAlwaysVisible(next);
}

export const taskbarStore = { alwaysVisible, setAlwaysVisible };
export default taskbarStore;
